import React from 'react'
import './Hivio.scss'

import HivioPhoto from '../Images/hivio-photo.avif'


const Hivio = () => {
  return (
    <div className='hivio full-width'>
    <div className='content main-grid'>
        
        <div className='client-description1'>
            <div className='client-text'>
                <h4 className='client-name unbounded-font'>Hivio</h4>

                <p className='desc-big inter-font'>
                The marketing strategy was crafted, resulting in increased brand awareness, targeted customer reach, and boosted sales.                </p>


                <p className='desc-small inter-font'>
                Digital marketing campaign with SEO, PPC, and social media. Offline activities included trade fair participation and product demonstrations. This combination led to successful goal achievement.                </p>

            </div>
            <div className='client-foto'>
                <img src={HivioPhoto} alt='hivio portfolio' />

            </div>
        </div>
    </div>
</div>
  )
}

export default Hivio